module.exports = __webpack_public_path__ + "img/main_4.3dde5fba.png";